import { Box, BoxProps, ColorOptions, ImageNew, ModalDialogNew, ModBox, Spacer, Text, TextProps } from '@jfs/ui-new'
import { useIsLargeScreen } from '@jfs/utils'
import { useIsFocused, useNavigation } from '@react-navigation/native'
import { FC, useEffect, useState } from 'react'
import { Linking, Platform, ScrollView, ViewProps } from 'react-native'
import { SvgImage } from '../../comps/SvgImage'
import { useLazyApiData, useStores } from '../../data/store'
import { Routes } from '../../nav/routes'
import { getString } from '../../util/languageStrings'
import { Colors, getFromStore, isMobile, isOsMobile, logEvent } from '../../util/util'
import { BillPaymentModal } from '../BillPayments/BillPaymentModal'
import { QuickLinks } from '../HomeNew/QuickLinks'
import { RecentTransactions } from '../HomeNew/RecentTransactions'
import BannerCarousal from './Carousal'
import { carousalData } from './Carousal/carousalData'
import { RenderMidList } from './RenderMidList'
import { VoiceBoxBTCarousal } from './VoiceBoxBTCarousal'

const Dashboard: FC = () => {
  const navigation = useNavigation()
  const {
    merchantName,
    getVideoList,
    getVideos,
    isTransactionTabEnabled,
    isUserManagementEnabled,
    sortedMerchants,
    selectedAppLanguage,
    disableBillPayment,
    mid,
    pairRequests,
    fetchPendingPairRequest,
  } = useStores((store) => ({
    merchantName: store?.settings?.metaData?.selectedMercName,
    getVideos: store.settings.metaData.getVideos,
    getVideoList: store.settings.metaData.getVideoList,
    isTransactionTabEnabled: store.userManagement.isTransactionTabEnabled(),
    isUserManagementEnabled: store.userManagement.isUserManagementEnabled(),
    sortedMerchants: store?.user?.sortedMerchants,
    selectedAppLanguage: store.settings.config.selectedAppLanguage,
    disableBillPayment: store.billPayments.user.disableBillPayment,
    mid: store.user.selectedMid,
    pairRequests: store.voiceBoxes.pairRequests.slice(),
    fetchPendingPairRequest: store.voiceBoxes.fetchPendingPairRequest,
  }))
  const merchantList = sortedMerchants()
  const [showMidList, setMidListVisible] = useState(false)
  const isLargeScreen = useIsLargeScreen()
  const isSmallDevice = isMobile(isLargeScreen)
  const mobileView = isMobile(!isSmallDevice)
  const [showBillPaymentModal, setShowBillPaymentModal] = useState(false)
  const [showChatbotAwarenessCount, setShowChatbotAwarenessCount] = useState(1000)

  const [getVideo, { state }] = useLazyApiData(getVideos)
  //const listData = getVideoList()

  const isFocussed = useIsFocused()

  useEffect(() => {
    try {
      fetchPendingPairRequest(mid)
    } catch (e) {
      console.log('Voicebox error is ', e)
    }
  }, [mid, fetchPendingPairRequest])

  useEffect(() => {
    if (isFocussed && isOsMobile()) {
      getFromStore('chatbotAwarenessShown')
        .then((res) => {
          setShowChatbotAwarenessCount(!!res && !isNaN(res) ? Number(res) : 0)
        })
        .catch((err) => {
          console.log(err)
        })
    }
  }, [isFocussed])

  // useEffect(() => {
  //   if (listData?.length === 0 && isOsMobile()) {
  //     getVideo()
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [])

  const handleNavigation = (item: any) => {
    logEvent('learn_videos_clicked', item.videoUrl)
    navigation.navigate('video' as never, { url: item.videoUrl } as never)
  }

  //const callbackFn = () => console.log('on action fn')
  const handleViewAll = () => {
    logEvent('btn_press', 'view_all_payments')
    navigation.navigate('transactions' as never)
  }

  const getLabelName = () => {
    const name = merchantName?.split(' ')
    let label: any = ''
    if (name[0]?.length) {
      label = label + name[0]?.slice(0, 1)?.toUpperCase()
    }
    if (name[1]?.length) {
      label = label + name[1]?.slice(0, 1)?.toUpperCase()
    }
    return label ?? null
  }

  const labelName = getLabelName()

  const switchMid = () => {
    logEvent('btn_press', 'switch_mid_home')
    setMidListVisible(true)
  }

  const onPressBanner = (data: any) => {
    if (data.key === '4') {
      setShowBillPaymentModal(true)
    } else if (data.link) {
      Linking.openURL(data.link)
    }
  }
  let modifiedCarousalData = [...carousalData]

  // if (disableBillPayment) {
  //   modifiedCarousalData.splice(3, 1)
  // }

  return (
    <Box flex={1} backgroundColor={Colors.SECONDARY} position={'relative'}>
      <ModBox flex={1}>
        <ModBox ph={25} pb={10}>
          <Spacer size={30} direction="vertical" />
          <Box flexDirection={'row'} align="center">
            <ModBox
              onPress={switchMid}
              testID="switch-mid"
              underlayColor={'PRIMARY'}
              zIndex={5}
              width={50}
              height={50}
              borderRadius={50}
              bg={'PRIMARY'}
              align="center"
              justify="center">
              <ModBox align="center" justify="center" overflow={'hidden'} borderRadius={80} width={80} height={80}>
                {labelName ? (
                  <Text
                    letterSpacing={-0.07}
                    fontFamily={'JioType-Bold'}
                    fontSize={14}
                    fontWeight={'700'}
                    color={Colors.WHITE as ColorOptions}>
                    {labelName}
                  </Text>
                ) : (
                  <SvgImage imageName="Union" />
                )}
              </ModBox>
            </ModBox>
            <Spacer size={15} direction="horizontal" />
            <Box f={1} onPress={switchMid} testID="switchMid" underlayColor={'TRANSPARENT'}>
              <Text lineHeight={24} fontFamily={'JioType-Bold'} fontSize={16} color="WHITE">
                {merchantName}
              </Text>
            </Box>
          </Box>
        </ModBox>
        <ScrollView
          contentContainerStyle={{ flexGrow: 1 }}
          showsVerticalScrollIndicator={true}
          keyboardShouldPersistTaps="always">
          <ModBox ph={25} f={isOsMobile() ? 0.5 : 1}>
            <RecentTransactions />
            <Spacer size={16} direction="vertical" />
            <VoiceBoxBTCarousal data={pairRequests} mid={mid} />

            <Spacer size={16} direction="vertical" />
            <ModBox
              show={isTransactionTabEnabled}
              onPress={handleViewAll}
              testID="viewAll"
              underlayColor="TRANSPARENT"
              flexDirection={'row'}
              alignItems="center">
              <Text fontFamily={'JioType-Medium'} fontSize={14} color={Colors.PRIMARY_STORNG}>
                {getString(selectedAppLanguage, 'viewAllPayments')}
              </Text>
              <Spacer size={5} direction="horizontal" />
              <SvgImage imageName="IconArrowNext" color={Colors.PRIMARY_STORNG} />
            </ModBox>
            <Spacer size={24} direction="vertical" />
          </ModBox>

          <ModBox {...(styles.listWrapper as BoxProps)} f={1} backgroundColor={'WHITE'}>
            <Box ph={24}>
              <Spacer size={8} direction="vertical" />
              <Text {...styles.titleFontStyle}>{getString(selectedAppLanguage, 'quickLinks')}</Text>
              <Spacer size={22} direction="vertical" />
            </Box>
            <QuickLinks
              showChatbotAwarenessCount={showChatbotAwarenessCount}
              disableBillPayment={disableBillPayment}
              isUserManagementEnabled={isUserManagementEnabled}
            />
            <Spacer size={32} direction="vertical" />

            {/* Mobile only Ads banner slider */}
            {isOsMobile() && <BannerCarousal onPressBanner={onPressBanner} data={modifiedCarousalData} />}

            {Platform.OS === 'android' && (
              <Box
                borderRadius={16}
                overflow="hidden"
                ph={24}
                underlayColor={'TRANSPARENT'}
                onPress={() => navigation?.navigate(Routes.CHATBOT as never, { isAfterLogin: true } as never)}>
                <Spacer size={16} direction="vertical" />
                <ImageNew
                  resizeMode={'stretch'}
                  source={require('../../assets/images/chatbot_banner.png')}
                  width={'100%'}
                  height={174}
                />
              </Box>
            )}
            <Spacer size={16} direction="vertical" />
            {/* <ModBox ph={24} show={isOsMobile()}>
              <Text {...styles.titleFontStyle}>{getString(selectedAppLanguage, 'learnNewTips')}</Text>
              <Spacer size={8} direction="vertical" />
              <ModBox
                mb={15}
                show={state === 'pending' || state === 'rejected'}
                bg={'BACKGROUND' as ColorOptions}
                alignItems="center"
                height={147}
                justifyContent="center">
                <EmptyView
                  onRetry={() => {
                    getVideo()
                  }}
                  isLoading={state === 'pending'}
                  error={state === 'rejected'}
                  loadingMessage=""
                  emptyMessage=""
                />
              </ModBox>
            </ModBox>
            <ModBox show={isOsMobile() && listData?.length > 0} {...styles.carousalContainer}>
              {listData?.length > 0 && (
                <Carousal data={listData} isSnapEnabled onPress={handleNavigation} isFromProfile={false} />
              )}
            </ModBox>
            <Spacer size={8} direction="vertical" /> */}
          </ModBox>
        </ScrollView>
        {/* <ModalDialog
          children={
            <RenderChatbotAwarenessWeb
              isSmallDevice={isSmallDevice}
              onPress={() => console.log('chat')}
              onCancel={() => setShowChatbotAwareness(false)}
            />
          }
          type={'Right'}
          show={showChatbotAwareness && !isOsMobile()}
          onDismiss={() => console.log('do not close')}
        /> */}
      </ModBox>

      <ModalDialogNew
        show={showMidList}
        type={'bottom'}
        animate={true}
        onDismiss={() => setMidListVisible(false)}
        backgroundColor="TRANSPARENT">
        <Box borderTopLeftRadius={24} borderTopRightRadius={24} bg="WHITE" overflow={'hidden'} pv={32} pb={10}>
          <Box ph={24} flexDirection={'row'} justifyContent="space-between" alignItems={'flex-start'} mb={22}>
            <Box width={'90%'}>
              <Text fontFamily="JioType-Black" fontSize={24}>
                {getString(selectedAppLanguage, 'switchAccount')}
              </Text>
            </Box>
            <Box testID="close-mid-list" onPress={() => setMidListVisible(false)} underlayColor={'TRANSPARENT'}>
              <SvgImage imageName="Close" />
            </Box>
          </Box>

          <RenderMidList setMidListVisible={setMidListVisible} merchantList={merchantList} mobileView={mobileView} />
        </Box>
      </ModalDialogNew>

      <ModalDialogNew
        onBackPress={() => setShowBillPaymentModal(false)}
        show={showBillPaymentModal && isOsMobile()}
        type="bottom"
        backgroundColor="TRANSPARENT">
        <BillPaymentModal
          showBillPaymentModal={showBillPaymentModal}
          onProceed={() => console.log('Bill pay request submitted')}
          onDismiss={(visible: boolean) => setShowBillPaymentModal(visible)}
          type={'INIT'}
        />
      </ModalDialogNew>
    </Box>
  )
}

const styles = {
  listWrapper: {
    backgroundColor: 'white',
    pv: 24,
    borderTopLeftRadius: 24,
    borderTopRightRadius: 24,
    width: '100%',
    zIndex: 4,
    overflow: 'auto',
    f: 1,
  } as ViewProps,
  carousalContainer: {
    height: 180,
  } as BoxProps,
  titleFontStyle: {
    fontFamily: 'JioType-Black',
    lineHeight: 24,
    fontSize: 18,
    color: Colors.BLACK_14 as ColorOptions,
  } as TextProps,
}

export default Dashboard
